"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const createContext = require("./context/context/create-context.js");
exports.createSlotsContext = createContext.createSlotsContext;
//# sourceMappingURL=index.js.map
